module.exports = __webpack_public_path__ + "static/2-5133a279505e6f6f03e5dd9514b9075a.jpeg";